import api from '..'

export type IndividualFilters = {
  user_id_in?: number[] | null
  user_id_not_in?: number[] | null
  g?: any
}

interface Options {
  filters: IndividualFilters
  withVersions?: boolean
}

const individualCourses = (
  courseId: number,
  { filters, withVersions }: Options
) => {
  return api.post(`/administration/courses/${courseId}/individual`, {
    q: filters,
    withVersions,
  })
}

export default individualCourses
